import React from 'react';

function TempSalarySelectField() {
  return '';
}

export default TempSalarySelectField;
